import React from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";

import SecureRoute from "./SecureRoute";
import VehicleLastPosition from "../../Components/Private/Locate/VehicleLastPosition";
import VehicleHistory from "../../Components/Private/Locate/VehicleHistory";
import SideMenu from "../../Components/Public/SideMenu/SideMenu";
import GeoBoundary from "../../Components/Private/Manage/GeoBoundary";
import User from "../../Components/Private/Manage/User";
import UserRole from "../../Components/Private/Manage/UserRole";
import Assets from "../../Components/Private/Operations/Assets";
import Vehicles from "../../Components/Private/Reports/Vehicles";
import SubCategory from "../../Components/Private/Reminders/SubCategory";
import ReminderType from "../../Components/Private/Reminders/ReminderType";
import Reminder from "../../Components/Private/Reminders/Reminder";
import History from "../../Components/Private/Reminders/History";

const ComponentRoute = () => {
  return (
    <Router>
      <div className="">
        <SideMenu />
        <Switch>
          <SecureRoute exact path="/" component={VehicleLastPosition} />
          <SecureRoute path="/locate" component={VehicleLastPosition} />
          <SecureRoute path="/history/:id" component={VehicleHistory} />
          <SecureRoute exact path="/manage/geoboundary" component={GeoBoundary} />
          <SecureRoute exact path="/manage/roles" component={UserRole} />
          <SecureRoute exact path="/manage/users" component={User} />
          <SecureRoute exact path="/operations/vehicles" component={Assets} />
          <SecureRoute exact path="/reports/vehicles" component={Vehicles} />
          <SecureRoute exact path="/reminder/subcategory" component={SubCategory} />
          <SecureRoute exact path="/reminder/type" component={ReminderType} />
          <SecureRoute exact path="/reminder/list" component={Reminder} />
          <SecureRoute exact path="/reminder/history" component={History} />
        </Switch>
      </div>
    </Router>
  );
};

export default ComponentRoute;
